<template>
  <div>
    <general-top-bar :title="$t('reports.customerLifetimeValueReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>
        </div>

        <div class="col-md-6">
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.interval')}}: <b>{{orders.valid[0]}}</b> - <b>{{orders.valid[1]}}</b></p>
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.churnRate')}}: <b>{{ isNaN(churnRate) ? 0 : churnRate.toFixed(2) }} %</b></p>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns">
          <data-tables-server
            @query-change="paginationChanged"
            v-loading="loading"
            :data="productsTableData"
            :total="totalOrders"
            :pagination-props="paginationProps"
            @row-click="goToRecord"
            @sort-change="handleSortChange"
            class="report-sales"
            key="sales-summary-table"
            style="width: 100%"
            ref="reportsTable"
          >
            <el-table-column class-name="centered-cell" :min-width="80" sortable="custom" prop="id" :label="$t('reports.clientId')" />
            <el-table-column class-name="centered-cell" :min-width="80" prop="year" :label="$t('general.year')" />
            <el-table-column class-name="centered-cell" :min-width="80" prop="month" :label="$t('general.month')" >
              <template slot-scope="props">
                {{ $t('months.' + props.row.month) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="160" prop="client_name" :label="$t('reports.clientName')" />
            <el-table-column class-name="centered-cell" :min-width="200" prop="email" :label="$t('reports.email')" />
            <el-table-column class-name="centered-cell" :min-width="120" prop="phone" :label="$t('reports.phone')" />
            <el-table-column class-name="centered-cell" :min-width="120" prop="segment" :label="$t('general.segment')" />
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="registration_date" :label="$t('reports.registrationDate')" />
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="first_order_date" :label="$t('reports.firstOrderDate')" />
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="last_order_date" :label="$t('reports.lastOrderDate')" />
            <el-table-column 
              class-name="centered-cell" 
              :min-width="140"
              prop="monthly_order_count"
              sortable="custom"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.monthlyOrderCount'), productsTableDataTotals.total_order_count)"
            >
            <template slot-scope="props">
                {{ props.row.monthly_order_count }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              prop="monthly_order_value_total"
              sortable="custom"
              :min-width="180"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.monthlyOrderValueTotal'), productsTableDataTotals.total_orders_value)"
            >
              <template slot-scope="props">
                {{ Math.round(Number(props.row.monthly_order_value_total)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="average_order_value" :label="$t('reports.averageOrderValue')" >
              <template slot-scope="props">
                {{ Number(props.row.average_order_value).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="monthly_order_average" :label="$t('reports.monthlyOrderAverage')" >
              <template slot-scope="props">
                {{ Number(props.row.monthly_order_average).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="120" prop="is_new_client" :label="$t('reports.isNewClient')" >
                <template slot-scope="props">
                {{ props.row.is_new_client ? $t('general.yes') : $t('general.no') }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="140" prop="is_inactive_client" :label="$t('reports.isInactiveClient')" >
                <template slot-scope="props">
                  {{ props.row.is_inactive_client ? $t('general.yes') : $t('general.no') }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="days_since_last_order" :label="$t('reports.daysSinceLastOrder')" />
            <el-table-column class-name="centered-cell" :min-width="160" prop="acquisition_channel" :label="$t('reports.acquisitionChannel')" />
            <el-table-column class-name="centered-cell" :min-width="160" sortable="custom" prop="estimated_clv" :label="$t('reports.estimatedCLV')" >
              <template slot-scope="props">
                {{ Number(props.row.estimated_clv).toFixed(2) }}
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isCustomerLifetimeValueReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isCustomerLifetimeValueReport () {
      if (this.isCustomerLifetimeValueReport) {
        this.getOrders()
      }
    }
  },
  created () {
    this.getOrders()
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls'
    this.verifyUserLocations()
    this.verifyUserMethods()
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      sortBy: [],
      sortOrder: [],
      paymentMethods: [],
      receiptOptions: [
        { label: this.$t('reports.withoutReceipt'), value: 1 },
        { label: this.$t('reports.withReceipt'), value: 2 }
      ],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(24, 'months')
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      noData: false,
      churnRate: 0,
      pagination: {
        page: 1,
        pageSize: 20
      }
    }
  },
  methods: {
    handleSortChange ({ prop, order }) {
      if (!order) {
        this.sortBy = []
        this.sortOrder = []
      } else {
        const direction = order === 'ascending' ? 'asc' : 'desc'
        this.sortOrder = [direction]
        this.sortBy = [prop]
      }

      this.getOrders()
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    renderHeaderWithTotal (h, label, total) {
      total = Math.round(Number(total))

      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [
        h('div', {
          style: {
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            minWidth: '0'
          }
        }, label),
        h('div', {
          style: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '4px'
          }
        }, [
          h('span', {
            style: {
              background: '#674BD2 !important',
              color: '#fff',
              borderRadius: '5px',
              padding: '2px 6px',
              fontWeight: 'bold',
              fontSize: '12px',
              lineHeight: '1',
              whiteSpace: 'nowrap',
              display: 'inline-block'
            }
          }, total)
        ])
      ])
    },
    paginationChanged (query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        this.pagination.page = query.page
        this.pagination.pageSize = query.pageSize
        this.getOrders(query)
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    goToRecord (row) {
      const route = this.$router.resolve({ path: `/customers/view/${row.id}` })
      window.open(route.href, '_blank')
      // this.globalGoToRecord(row, event, column, '/customers/view/')
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isCustomerLifetimeValueReport) {
        return
      }
      if (this.loading) {
        return
      }

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1],
        sort_by: this.sortBy,
        sort_order: this.sortOrder
      }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      this.loading = true
      const pageSize = query ? query.pageSize : this.pagination.pageSize
      const page = query ? query.page : this.pagination.page

      this.apiRequest('/reports/v2/customer-lifetime-value' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=', 'GET', data, response => {
        if (response.status) {
          // this.$nextTick(() => {
          this.productsTableData = response.data
          this.productsTableDataTotals = response.totals
          this.totalOrders = response.pagination.total
          this.paginationProps.currentPage = response.pagination.page
          this.paginationProps.pageSize = response.pagination.perPage
          this.pagination.page = response.pagination.page
          this.pagination.pageSize = response.pagination.perPage
          this.churnRate = parseFloat(response.churn_rate_percentage) || 0
          // })
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      let fromDate = this.orders.valid[0]
      let toDate = this.orders.valid[1]

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        perPage: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/master-report-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .report-sales .cell span,
  span .caret-wrapper {
    background: none !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/CustomerLifetimeValue.vue